import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { Checkbox, Button, Typography } from 'antd';

const AntCheckboxGroup = ({ options, deleteFn, values, onChange, isButton }) => {
  return (
    <Checkbox.Group onChange={onChange} value={values} style={{ minWidth: '100%' }}>
      {options.map((option, index) => (
        <div key={index} style={{ marginBottom: '10px', width: '100%' }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              border: isButton ? '1px solid #e8e8e8' : '',
              borderRadius: isButton ? '4px' : '',
              padding: isButton ? '2px' : '',
              backgroundColor: values?.includes(option.value) && isButton ? '#f0f0f0' : 'white',
            }}
          >
            <Checkbox value={option.value} style={{ width: '100%' }}>
              <Typography
                style={{
                  fontSize: values?.includes(option.value) ? '16px' : '14px',
                  color: values?.includes(option.value) ? 'blue' : 'black',
                }}
              >
                {option.label}
              </Typography>
            </Checkbox>
            {deleteFn && (
              <Button
                type="text"
                shape="circle"
                icon={<CloseCircleOutlined style={{ color: '#ff9999' }} />}
                onClick={() => deleteFn(index)}
              />
            )}
          </div>
        </div>
      ))}
    </Checkbox.Group>
  );
};

export default AntCheckboxGroup;
